<template>

    <div class="layout-legal">
        <v-the-header></v-the-header>
        <div class="layout-legal-body">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <v-the-footer></v-the-footer>
    </div>

</template>

<style lang="scss">

    .layout-legal {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        .layout-legal-body {
            flex-grow: 1;
            padding: 120px 0 60px 0;
            position: relative;
            article {
                margin: 0 0 30px 0;
            }
            h1 {
                @include font-semibold(20px);
                color: $color-text;
                line-height: 1.4em;
                margin: 0 0 30px 0;
            }
            h2 {
                @include font-semibold(16px);
                color: $color-text;
                line-height: 1.6em;
                margin: 0 0 15px 0;
            }
            p, ol, ul {
                @include font-medium(14px);
                color: $color-text;
                line-height: 1.8em;
                margin: 0 0 15px 0;
            }
            a {
                color: $color-link;
                &:hover {
                    color: $color-link-hover;
                }
            }
        }
    }

</style>

<script>

import TheFooter from '@cmp/TheFooter';
import TheHeader from '@cmp/TheHeader';

export default {

    components: {
        'v-the-footer': TheFooter,
        'v-the-header': TheHeader,
    },

}

</script>
